import { render } from "./ProfilePanelMoreContextButton.vue?vue&type=template&id=21b4de5b&scoped=true"
import script from "./ProfilePanelMoreContextButton.vue?vue&type=script&lang=js"
export * from "./ProfilePanelMoreContextButton.vue?vue&type=script&lang=js"

import "./ProfilePanelMoreContextButton.vue?vue&type=style&index=0&id=21b4de5b&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b4de5b"]])

export default __exports__